import React, { useState } from 'react';
import Validator from '../../../Components/Validator';
import InputField from '../../../Components/InputField';
import Button from '../../../Components/Button';
import { SuccessAlert, ErrorAlert } from '../../../Components/Alert';
import useAxiosCall from '../../../Hooks/useAxiosCall';
import PasswordInput from '../../../Components/PasswordInput';

const LoginForm = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    username: '',
    loginPassword: '',
  });

  const [alert, setAlert] = useState({ type: '', message: '' });

  // This state is used to force a re-render
  const [updated, setUpdated] = useState(false);

  const validator = Validator();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleApiCallSuccess = (data) => {
    setAlert({ type: 'success', message: data.message + ' Redirecting...' });

    setTimeout(() => {
      onSubmit({ ...data, loginUsername: formData.username });
    }, 1500);
  };

  const handleApiCallError = (errorMessage) => {
    setAlert({ type: 'error', message: errorMessage });
  };

  const { makeApiCall } = useAxiosCall();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (validator.allValid()) {
      try {
        const requestData = {
          username: formData.username,
          password: formData.loginPassword,
        };

        await makeApiCall({
          requestData,
          onSuccess: handleApiCallSuccess,
          onError: handleApiCallError,
          requestType: 'POST',
          url: 'login',
        });
      } catch (error) {
        console.error('API call error:', error);
      }
    } else {
      validator.showMessages();
      // Toggle the updated state to force a re-render
      setUpdated(!updated);
    }
  };

  return (
    <form onSubmit={handleSubmit} noValidate>
      {alert.type === 'success' && <SuccessAlert success={true} messages={[alert.message]} resetAlert={setAlert} />}
      {alert.type === 'error' && <ErrorAlert error={true} messages={[alert.message]} resetAlert={setAlert} />}

      <FieldWrapper>
        <InputField
          id="username"
          name="username"
          type="text"
          value={formData.username}
          label="Email or Username"
          onChange={handleInputChange}
          autoComplete="username"
        />
        {validator.message('username', formData.username, 'usernameRequired|usernameNoSpace')}
      </FieldWrapper>

      <FieldWrapper>
        <PasswordInput
          id="loginPassword"
          name="loginPassword"
          value={formData.loginPassword}
          label="Password"
          onChange={handleInputChange}
        />
        {validator.message('loginPassword', formData.loginPassword, 'passwordRequired|passwordLength')}
      </FieldWrapper>

      <Button type="submit" block className="mb-4">
        Login
      </Button>
    </form>
  );
};

const FieldWrapper = ({ children }) => (
  <div className="mb-4">
    {children}
  </div>
);

export default LoginForm;
